import React from "react";
import { Search, LayoutGrid, Handshake, Wrench, TrendingUp } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Search,
    title: "Discover",
    body: "Understand opportunity, market and client objectives.",
  },
  {
    n: "02",
    icon: LayoutGrid,
    title: "Structure",
    body: "Build business model, strategy and execution plan.",
  },
  {
    n: "03",
    icon: Handshake,
    title: "Partner",
    body: "Identify technology, OEM and investment partners.",
  },
  {
    n: "04",
    icon: Wrench,
    title: "Implement",
    body: "Support deployment, integration and localization.",
  },
  {
    n: "05",
    icon: TrendingUp,
    title: "Scale",
    body: "Build long-term growth, recurring revenue and regional expansion.",
  },
];

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#0A1128] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-navy opacity-40 pointer-events-none" />
      {/* Floating leaf motif */}
      <svg
        className="absolute -right-16 top-10 w-[420px] h-[420px] opacity-25 hidden md:block floaty"
        viewBox="0 0 400 400"
        aria-hidden="true"
      >
        <path
          d="M60 260 C 90 130, 250 90, 340 120 C 340 240, 240 340, 130 340 C 90 340, 60 320, 60 260 Z"
          fill="#00D084"
          opacity="0.35"
        />
        <path
          d="M80 280 C 140 210, 220 160, 320 140"
          stroke="#00D084"
          strokeWidth="1.5"
          fill="none"
        />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <div className="overline mb-5" style={{ color: "#00D084" }}>
            How we work
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05]">
            Our approach.
          </h2>
          <p className="mt-5 text-white/70 text-lg max-w-xl">
            A five-step operating framework that converts complex opportunities into executed,
            scalable outcomes.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-5 gap-6">
          {/* Connecting line (desktop) */}
          <div
            className="hidden md:block absolute top-14 left-[6%] right-[6%] h-px"
            style={{
              background:
                "linear-gradient(to right, rgba(0,208,132,0.0), rgba(0,208,132,0.6), rgba(0,208,132,0.0))",
            }}
          />
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`approach-step-${i + 1}`}
                className="relative bg-white/[0.03] border border-white/10 rounded-2xl p-6 backdrop-blur-sm card-lift"
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-xl bg-[#00D084]/15 border border-[#00D084]/30 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#00D084]" />
                  </div>
                  <span className="stat-number text-2xl text-white/30">{s.n}</span>
                </div>
                <h3 className="mt-6 font-display text-2xl font-medium tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-white/70 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
